export default "__VITE_ASSET__Bu716xby__"